import React from "react";
import ReportTableSectionRenderer from "../../../../../../libraries/ReportGenerator";
import { AirBrakeReportASchema } from "./lvlOneSchema";
import { getOtherActivityTable, getSupportingDocuments, titleOfReport } from "../CommonFunctions";

function CLMB_AirBrakeLvlOne(props) {
  const { singleReport } = props;

  return (
    <div>
      <span className="spacer"></span>
      <div style={{ textAlign: "center" }}>
        <h2 style={{ fontWeight: "bolder" }}>{titleOfReport(singleReport.testCode) || singleReport.title}</h2>
      </div>
      <table className="table-bordered">
        {AirBrakeReportASchema.map((section, index) => {
          return <ReportTableSectionRenderer section={section} rowsData={singleReport.summary} key={index} />;
        })}
      </table>

      {Object.keys(singleReport.summary).includes("otherActivity") && getOtherActivityTable(singleReport.summary)}
      {Object.keys(singleReport.summary).includes("supportingDocuments") && getSupportingDocuments(singleReport.summary)}
    </div>
  );
}

export default CLMB_AirBrakeLvlOne;



// WEBPACK FOOTER //
// ./src/components/Reports/ReVAMP/AirBrakeReports/AirBrakeReports/CLMB/AirBrakeReportLevelOne.jsx